// extracted by mini-css-extract-plugin
export default {"filterContainer":"AllSongs_filterContainer__P9vDd","tableRow":"AllSongs_tableRow__ZmvDE","deleteBtn":"AllSongs_deleteBtn__9bsSp","editBtn":"AllSongs_editBtn__loWka"};